import { vMaska } from "maska/vue";
import type { MaskInputOptions } from "maska";
import { useMask } from "@/core/plugins/maska/useMask";
import { EMascaraNomeada } from "../../../../@types/IntegracaoCampoEnum";

export type TNamedMask = MaskInputOptions | string;

export default function useNamedMask() {
  const { masks } = useMask();

  const maskByName: Record<EMascaraNomeada, TNamedMask> = {
    [EMascaraNomeada.Cnpj]: masks.CNPJ,
    [EMascaraNomeada.Cpf]: masks.CPF,
    [EMascaraNomeada.Cep]: masks.CEP,
    [EMascaraNomeada.Telefone]: masks.PHONE,
    [EMascaraNomeada.Percentage]: {
      mask: "###.###.###,##%",
      reversed: true
    }
  };

  const resolveMask = (
    name: string | null | undefined
  ): TNamedMask | undefined => {
    if (!name) return undefined;
    const names = Object.values(EMascaraNomeada) as string[];

    return names.includes(name)
      ? maskByName[name as EMascaraNomeada]
      : undefined;
  };

  return {
    vMaska,
    resolveMask
  };
}
